import React, { useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import * as PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import styleConstants from "../../../styleConstants";
import DownloadIcon from "../../widgets/DownloadIcon";
import DownloadMenu from "../../widgets/DownloadMenu";

const useStyles = makeStyles({
  container: {
    backgroundColor: "#ffffff",
    borderTop: `2px solid ${styleConstants.colors.themeBlue}`,
    width: "fit-content",
    margin: "2rem 0 4rem"
  },
  contentContainer: {
    padding: "1rem 2rem 2rem"
  },
  content: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center"
  },
  reference: {
    display: "inline-block",
    backgroundColor: styleConstants.colors.themeBlue,
    padding: "0.5rem",
    fontSize: "0.875rem",
    fontWeight: styleConstants.fontWeights.bold,
    textTransform: "uppercase",
    color: "white"
  },
  headingContainer: {
    display: "flex",
    justifyContent: "space-between"
  },
  button: {
    marginTop: "-12px"
  }
});

const AnnexTable = props => {
  const [downloadMenuAnchorElement, setDownloadMenuAnchorElement] = useState();

  const classes = useStyles(props);

  const handleClose = () => {
    setDownloadMenuAnchorElement(undefined);
  };

  return (
    <div id={props.id} className={classes.container}>
      <div className={classes.reference}>{props.reference}</div>
      <div className={classes.contentContainer}>
        <div className={classes.headingContainer}>
          <div className={classes.titleContainer}>
            <h4 className="figure-title">{props.title}</h4>
            <h4 className="figure-subtitle">{props.subtitle}</h4>
          </div>
          <div>
            <IconButton
              className={classes.button}
              aria-label="download"
              disableFocusRipple={true}
              edge="end"
              onClick={e => {
                setDownloadMenuAnchorElement(e.currentTarget);
              }}
            >
              <DownloadIcon />
            </IconButton>

            <DownloadMenu
              anchorElement={downloadMenuAnchorElement}
              open={!!downloadMenuAnchorElement}
              onDownloadCsv={() => {
                props.onDownloadCsv();

                handleClose();
              }}
              onClose={() => {
                handleClose();
              }}
            />
          </div>
        </div>
        <div className={classes.content}>{props.children}</div>
      </div>
    </div>
  );
};

AnnexTable.propTypes = {
  id: PropTypes.string.isRequired,
  reference: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.element.isRequired,
  onDownloadCsv: PropTypes.func.isRequired
};

export default AnnexTable;
